// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBmqWcksNai_pZIhGsrIFKWM9xhkKZAmDY",
  authDomain: "ravi-edu.firebaseapp.com",
  projectId: "ravi-edu",
  storageBucket: "ravi-edu.firebasestorage.app",
  messagingSenderId: "236027925555",
  appId: "1:236027925555:web:754c52476578fb95a17f46",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db , storage};
